import React from 'react';
import {Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router';
import {useSession} from '../../../../firebase/UserProvider';
import {useReports} from './hooks/useReports';
import {REPORT_STATUS, TABLE_COLUMNS} from './constants';
import ReportsTable from './components/ReportsTable';

/**
 * Main component for displaying a list of reports for review
 * @returns {JSX.Element}
 */
const ListOfReports = () => {
    const navigate = useNavigate();
    const {user} = useSession();
    const {reports, loading} = useReports(user?.uid);

    const handleRowClick = (reportId) => {
        navigate(`/products/${reportId}`);
    };

    const pendingCount = reports.filter(r => r.status === REPORT_STATUS.AWAITING_REVIEW).length;
    const approvedCount = reports.filter(r => r.status === REPORT_STATUS.APPROVED).length;

    const headerText = loading
        ? 'Loading…'
        : pendingCount > 0
            ? `${pendingCount} pending review${pendingCount !== 1 ? 's' : ''}${approvedCount > 0 ? ` · ${approvedCount} approved` : ''}`
            : approvedCount > 0
                ? `All caught up · ${approvedCount} approved`
                : 'All caught up';

    return (
        <Stack p={2} spacing={3}>
            <Typography variant="h5">{headerText}</Typography>

            <ReportsTable
                reports={reports}
                columns={TABLE_COLUMNS}
                loading={loading}
                onRowClick={handleRowClick}
            />
        </Stack>
    );
};

export default ListOfReports;
